.card {
    aspect-ratio: 382 / 133;
    background-color: var(--mantine-color-white);
    overflow: hidden;
    position: relative;
}

.background {
    background: url('/static/img/oura-promo-card-bg.png') 0% 45% / 115% auto
        no-repeat;
    inset: 0;
    opacity: 0.4;
    position: absolute;
}
